import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit } from '@angular/core';

import { trackByIndex } from 'src/app/shared/utils/track-by.util';
import { TranslateService } from '../../../../services/translate.service';
import { SegControlRow, SegProfile } from '../../../../services/template-mappers/entities/risk-register-seg-group.model';
import { SEG_STYLES } from '../seg-profile/seg-profile-presentation.service';

/** A SEG paired with its (optionally capped) list of controls, pre-computed for the view. */
interface SegControlsRow {
    segName: string;
    controls: SegControlRow[];
}

@Component({
    standalone: true,
    selector: 'app-seg-controls-widget',
    imports: [],
    templateUrl: './seg-controls-widget.component.html',
    styleUrl: './seg-controls-widget.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SegControlsWidgetComponent implements OnInit, OnChanges {
    @Input() profiles: SegProfile[] | null = null;
    /** 0 = show all controls; a positive value caps the rows per SEG. */
    @Input() maxControls = 0;

    /** Pre-computed per-SEG rows — avoids a method call in the template's *ngFor. */
    rows: SegControlsRow[] = [];

    readonly styles = SEG_STYLES;
    labels: Record<string, string> = {};

    constructor(private translateService: TranslateService) { }

    ngOnInit(): void {
        const t = (key: string) => this.translateService.getDynamicTranslation(key);
        this.labels = {
            heading: t('Controls'), code: t('Code'), name: t('Name'), type: t('Type'), bucket: t('Bucket'),
            owner: t('Owner'), status: t('Status'), target: t('Target Dates'), actual: t('Actual Dates'),
            linkType: t('Link Type'), noData: t('No Data Available')
        };
    }

    ngOnChanges(): void {
        const cap = this.maxControls;
        this.rows = (this.profiles ?? []).map(seg => ({
            segName: seg.segName,
            controls: cap > 0 ? seg.controls.slice(0, cap) : seg.controls
        }));
    }

    public trackByIndex = trackByIndex;
}
